(function(Drupal, $) {
  Drupal.behaviors.dedicateRoses = {
    attach: function(context) {
      var $helpText = $('#edit-amount--description', context);
      var $additionalRosesSelect = $('#edit-do-you-want-to-dedicate-additional-roses-', context);

      $additionalRosesSelect.change(function() {
        var totalRoses = $additionalRosesSelect.val();
        Drupal.behaviors.dedicateRoses.changeHelpText($helpText, totalRoses);
      });
    },

    changeHelpText: function($helpText, totalRoses) {
      if (totalRoses > 0) {
        var numberRoses = parseInt(totalRoses) + 1;
        var suggestedValue = numberRoses * 10;
        $helpText.text('We suggest a minimum donation of £'+ suggestedValue + ' to dedicate ' + numberRoses +  ' roses');
      } else {
        $helpText.text('We suggest a minimum donation of £10 to dedicate a rose');
      }
    }
  };
})(Drupal, jQuery);
